import React from 'react';
import {ColorPicker as AntdColorPicker, Button} from 'antd' 
import { Controller, useFormContext } from 'react-hook-form';

interface ColorPickerProps {
  name: string,
  defaultValue?: string,
  className?: string,
  allowClear?: boolean,
}

const ColorPicker: React.FC<ColorPickerProps> = ({ name, ...props }) => {
  const form = useFormContext()

  return (
    <Controller
       name={name}
       control={form.control}
       render={({field: {onChange, value}}) => (
        <AntdColorPicker
          value={value}
          onChange={(_, hex) => onChange(hex)}
          onClear={() => onChange(null)}
          showText
          disabledAlpha
          size='large'
          {...props}
        >
          {!value && <Button size='large'>Choose color</Button>}
        </AntdColorPicker>)}  
    />

  );
};

export default ColorPicker;

